<template>
  <FormContainer withoutDivider>
    <template #title>
      Liste des module(s) de formation
      <BasicAlert
        v-if="metaModuleEnCours?.$messageErreurDirty!"
        :alertLabel="metaModuleEnCours?.$messageErreurDirty!"
      />
    </template>
    <template #header-actions>
      <BasicButton
        variant="outlined"
        :label="!nbMaxModulesAtteint ? 'Ajouter un module de formation' : 'Nombre maximum de modules atteint'"
        :icon-name="!nbMaxModulesAtteint ? 'add' : 'danger'"
        @click="afficherModale = true"
        :disabled="nbMaxModulesAtteint || readonly"
      />
    </template>
    <template
      #content
      v-if="listeModules && listeModules.length"
    >
      <!-- Desktop version -->
      <div class="elements--desktop">
        <div class="cardLayoutWrapper cardLayoutWrapper--header">
          <div class="elem elem--span-2"></div>
          <div class="elem elem--span-2">
            <span>N°</span>
          </div>
          <div class="elem elem--span-1"></div>
          <div class="elem elem--span-8">
            <span>Type de module</span>
          </div>
          <div class="elem elem--span-7">
            <span>Date de début</span>
          </div>
          <div class="elem elem--span-7">
            <span>Date de fin</span>
          </div>
          <div class="elem elem--span-8">
            <span>Modalité pédagogique</span>
          </div>
        </div>

        <div
          v-for="(module, index) in listeModules"
          class="listCardDesktopWrapper"
          :key="index"
        >
          <div
            class="cardLayoutWrapper cardLayoutWrapper--selectionnable"
            :class="{ isActive: activeModuleIndex === index }"
            @click="définirModuleEnCours(index)"
          >
            <BasicAlert
              v-if="meta.formation?.modules?.at(index)?.$estErreur"
              :has-bg="false"
              class="elem elem--span-2"
            />
            <div
              v-else
              class="elem elem--span-2"
            ></div>
            <div class="elem elem--span-2">
              <BasicText>{{ index + 1 }}</BasicText>
            </div>
            <div class="elem elem--span-1"></div>
            <div class="elem elem--span-8">
              <BasicText>{{ module.typeModule }}</BasicText>
            </div>
            <div class="elem elem--span-7">
              <BasicText>{{ dateFormatter(module.dateDebut) }}</BasicText>
            </div>
            <div class="elem elem--span-7">
              <BasicText>{{ dateFormatter(module.dateFin) }}</BasicText>
            </div>
            <div class="elem elem--span-8">
              <BasicText>{{module.modalitePedagogique ? ModalitePedagogiqueLibelle[module.modalitePedagogique] : ''}}</BasicText>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile version -->
      <div class="elements--mobile">
        <div
          v-for="(module, index) in listeModules"
          :key="index"
          :class="['card', { 'card--active': activeModuleIndex === index }]"
          @click="définirModuleEnCours(index)"
        >
          <div class="card__header">
            <BasicText weight="bold">#{{ index + 1 }} Organisme de formation {{ module.typeModule }}</BasicText>
          </div>
          <div class="card__content">
            <BasicText>
              <BasicText weight="bold">Du</BasicText>
              {{ dateFormatter(module.dateDebut) }}
              <BasicText weight="bold">au</BasicText>
              {{ dateFormatter(module.dateFin) }}
            </BasicText>
            <BasicText wrap>
              <BasicText weight="bold">Modalité pédagogique :</BasicText>
              {{module.modalitePedagogique ? ModalitePedagogiqueLibelle[module.modalitePedagogique] : ''}}
            </BasicText>
          </div>
        </div>
      </div>
    </template>
    <template
      #content
      v-else
    >
      <!-- Empty state -->
      <BasicAlert
        v-if="meta.formation?.modules && meta.formation?.modules.$estErreurDirty"
        :alertLabel="meta.formation?.modules.$messageErreurDirty!"
      />
      <EmptyDataTable>
        <template #content>
          Retrouvez ici la
          <strong>liste des modules de formation que vous avez ajoutés</strong>
          (jusqu'à 5 maximum). Vous devez en ajouter un au minimum.
        </template>
      </EmptyDataTable>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { EmptyDataTable, FormContainer } from '@/features/interface/demande/shared'
  import { dateFormatter } from '@/features/shared/tools'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'
  import { PROA_MODULES_ACTIONS } from '../../useModuleActions'
  import { ModalitePedagogiqueLibelle } from '@/features/domaine/types/opco/Demande/PROA'

  const store = useDemandePROAStore()
  const { meta, readonly } = storeToRefs(store)
  const {
    nbMaxModulesAtteint,
    afficherModale,
    activeModuleIndex,
    listeModules,
    définirModuleEnCours,
    metaModuleEnCours,
  } = inject(PROA_MODULES_ACTIONS)!
</script>
